module.exports = __webpack_public_path__ + "img/canceled.0f902e04.svg";